module.exports = __webpack_public_path__ + "img/construction-careers.8bbaf04f.jpg";